/*
 * @Description:
 * @Date: 2022-10-11 15:09:50
 */
import { PAY_BANK_TYPE_KEY, PAY_TYPE_KEY } from '@/common/constants/bank';
import store from '@/store';

export const payBankFormatter = row => {
  if (!row[PAY_BANK_TYPE_KEY]) return '-';
  return store.state.bank.banks[row[PAY_BANK_TYPE_KEY]].label;
};
//服务商付款方式
export const payTypeFormatter = row => {
  if (!row[PAY_TYPE_KEY]) return '-';

  if (row.payTypeName) return row.payTypeName;

  const payMethodObj = store.state.bank.payMethod.find(
    item => +item.value === +row[PAY_TYPE_KEY]
  );
  return payMethodObj ? payMethodObj.label : '-';
};

// 由于PAY_BANK_TYPE_KEY可能会变，在此使用对象包起来
export const bankRowLabelFiled = {
  [PAY_BANK_TYPE_KEY]: {
    label: '支付通道',
    prop: PAY_BANK_TYPE_KEY,
    width: '120px',
    formatter(r) {
      return payBankFormatter(r);
    }
  }
};

export const payTypeRowLabelFiled = {
  [PAY_TYPE_KEY]: {
    label: '服务商付款方式',
    prop: PAY_TYPE_KEY,
    width: '120px',
    formatter(r) {
      return payTypeFormatter(r);
    }
  }
};

export const bankSearchFiled = {
  width: 150,
  id: PAY_BANK_TYPE_KEY,
  key: PAY_BANK_TYPE_KEY,
  label: '支付通道',
  tip: '支付通道',
  required: false,
  slot: 'ajaxSelect',
  clearable: true,
  prop: {
    label: 'label',
    code: 'value'
  },
  ajax: () => {
    return new Promise(resolve =>
      resolve({
        data: {
          data: Object.values(store.state.bank.banks)
        }
      })
    );
  }
};

export const payTypeSearchFiled = {
  width: 150,
  id: PAY_TYPE_KEY,
  key: PAY_TYPE_KEY,
  label: '服务商付款方式',
  tip: '服务商付款方式',
  required: false,
  slot: 'ajaxSelect',
  clearable: true,
  prop: {
    label: 'label',
    code: 'value'
  },
  ajax: () => {
    return new Promise(resolve =>
      resolve({
        data: {
          data: Object.values(store.state.bank.payMethod)
        }
      })
    );
  }
};
